import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import VueLazyload from 'vue-lazyload'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import '../src/plugins/global-elements.js'
import '../src/plugins/global-icons.js'
import '../lib/icons/fontastic/styles.css'
import '../lib/icons/fantasticon/build/fantasticon.css'
import '../src/plugins/function.js'
import i18n from '../src/plugins/i18n.js'
import '../public/css/font-stylesheet.css'

Vue.use(ElementUI, { locale })

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/img/img-not-found.jpg',
  loading: '/img/loading-spin.svg',
  attempt: 1
})

Vue.config.productionTip = false
Vue.prototype.$cookieSettings = JSON.parse(localStorage.getItem('cookieSettings')) // get storage cookie

new Vue({
  router,
  store,
  render: h => h(App),
  i18n
}).$mount('#app')
